import React, {Component} from 'react';
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import {ModalHeader, ModalBody, ModalFooter, Modal, Button} from "reactstrap";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import 'ladda/dist/ladda-themeless.min.css';
import {toast} from "react-toastify";
import api from 'api';

class ConfigurationDeleteButton extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      deleting: false
    }
  }

  configurationDelete(){
    this.setState({
      deleting: true
    });

    api.configuration.delete({
      id: this.props.configuration.id
    }).then(() => {
      this.props.handleChange();
      toast.success(<FormattedMessage id="admin.configurationDeleteButton.toast.success" />);
    }).catch(() => {
      this.setState({
        deleting: false
      });
    });
  }

  toggleModalDelete(){
    this.setState({
      modal: !this.state.modal
    })
  }

  render() {
    const { deleting } = this.state;

    const modal = <Modal isOpen={this.state.modal} toggle={() => this.toggleModalDelete()}>
      <ModalHeader toggle={() => this.toggleModalDelete()} tag="h2"><FormattedMessage id="admin.configurationDeleteButton.modalHeader" /></ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        <p><FormattedMessage id="admin.configurationDeleteButton.modalBody" /></p>
      </ModalBody>
      <ModalFooter>
        <FormattedMessage id="_.modal.delete.confirmation">{
          (message) => <LaddaButton
            className="btn btn-danger btn-ladda"
            loading={deleting}
            data-style={ZOOM_OUT}
            onClick={() => this.configurationDelete()}
          >
            {message}
          </LaddaButton>
        }</FormattedMessage>
        <FormattedMessage id="_.button.cancel">{
          (message) =>
            <Button color="secondary" onClick={() => this.toggleModalDelete()}>{message}</Button>
        }</FormattedMessage>

      </ModalFooter>
    </Modal>;

    return (
      <React.Fragment>
        <span className="fas fa-times mr-2 pointer" onClick={() => this.toggleModalDelete()}/>
        {modal}
      </React.Fragment>
    )
  }
}

ConfigurationDeleteButton.propTypes = {
  configuration: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired
};

export default ConfigurationDeleteButton;